// react components
import React from 'react'
import {
    Link,
} from 'react-router-dom'

// props
type LinkHelper825Props = {
    children?: React.ReactNode
    className?: string
    edit: boolean
    href?: string
    hrefTarget?: string
    hrefTargetSystem?: boolean
    noContentDetailClose?: boolean
    onClick?: () => void
    styles?: any
    title?: string
    to?: string | false
}

// main
export const LinkHelper825: React.FC<LinkHelper825Props> = React.memo(({
    children,
    className,
    edit,
    href,
    hrefTarget,
    hrefTargetSystem,
    noContentDetailClose,
    onClick,
    styles,
    title,
    to,
}) => {

    function onLinkClick() {
        if (onClick) onClick()
    }

    if (edit) {
        return (
            <span
                className={className}
                style={styles}
                title={title}
            >
                {children}
            </span>
        )
    }
    if (href) {
        return (
            <a
                className={className}
                href={href}
                rel='noopener noreferrer'
                style={styles}
                target={hrefTarget || '_blank'}
                title={title}
            >
                {children}
            </a>
        )
    }
    if (to) {
        return (
            <Link
                className={className}
                onClick={() => onLinkClick()}
                style={styles}
                title={title}
                to={to}
            >
                {children}
            </Link>
        )
    }
    return (
        <span
            className={className}
            onClick={() => onLinkClick()}
            style={styles}
            title={title}
        >
            {children}
        </span>
    )
})
